import {ForYouItem} from '../shared/ForYouItem'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {decideChecksItem} from './shared/checks-item-decider'
import {useMergeabilityData} from './use-mergeability-data'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'

// Renders when checks are still running and no workflow approval is pending
export function PendingChecks({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!data || decideChecksItem(data).kind !== 'pending') {
    return null
  }

  const {statusRollup, checksSection} = data

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} size={16} />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="pending-checks"
      padding="none"
      variant={variant}
      description={accessibleChecksSummary(statusRollup.summary)}
    >
      <PendingChecksBody
        data={data}
        itemName="pending-checks"
        emptyMessage="No checks have been reported for this pull request yet."
      />
    </ForYouItem>
  )
}
